import { ROLES } from "./ROLES";

// new permission name - old permission name
export const PERMISSIONS = [
    "users.read", // "guard.users.read"
    "users.write", // "guard.users.write"
    "stats.read", // "shop.dashboards.read"
    "orders.read", // "shop.orders.read"
    "orders.status.write", // "shop.orders.status.write"
    "orders.write", // "shop.orders.write"
    "subscriptions.read", // "shop.subscriptions.read"
    "subscriptions.write", // "shop.subscriptions.write"
    "subscriptions.users.read", // "shop.usersubscriptions.read"
    "subscriptions.users.write", // "shop.usersubscriptions.write"
    "orders.links.read", // "shop.orders.links.read"
    "orders.links.write", // "shop.orders.links.write"
    "orders.quota.checkout", // "shop.orders.quota.checkout"
    "orders.quota.read", // "shop.orders.quota.read"
    "orders.quota.write", // "shop.orders.quota.write"
    "tasks.read", // new
    "tasks.write", // new
    "products.read", // new
    "products.write", // new
    "usecases.read", // new
    "usecases.write", // new
    "reports.read", // new
    "reports.write", // new
    "contracts.read", // new
    "contracts.write", // new
    "businessPartners.read", // new
    "businessPartners.write", // new
    "users.sales.register" // new
] as const;

export type Permission = typeof PERMISSIONS[number];

export interface IRolePermissions {
    [role: string]: Permission[];
}

export const PERMISSIONS_BY_ROLES: IRolePermissions = {
    [ROLES.shopViewer]: [
        "users.read",
        "orders.read",
        "subscriptions.read",
        "subscriptions.users.read"
    ],
    [ROLES.shopManager]: [
        "users.read",
        "users.write",
        "orders.read",
        "orders.status.write",
        "subscriptions.read",
        "subscriptions.users.read",
        "subscriptions.users.write",
        "orders.links.write",
        "orders.links.read",
        "orders.quota.read",
        "products.read"
    ],
    [ROLES.admin]: [
        "users.read",
        "users.write",
        "stats.read",
        "orders.read",
        "orders.write",
        "orders.status.write",
        "subscriptions.read",
        "subscriptions.write",
        "subscriptions.users.read",
        "subscriptions.users.write",
        "orders.links.write",
        "orders.links.read",
        "orders.quota.write",
        "orders.quota.read",
        "orders.quota.checkout",
        "tasks.read",
        "tasks.write",
        "products.read",
        "products.write",
        "usecases.read",
        "usecases.write",
        "reports.read",
        "reports.write",
        "contracts.read",
        "contracts.write",
        "businessPartners.read",
        "businessPartners.write",
        "users.sales.register"
    ],
    [ROLES.eurex]: [
        "orders.quota.checkout",
        "orders.quota.read",
        "orders.links.read",
        "orders.links.write"
    ],
    [ROLES.sales]: [
        "users.sales.register"
    ]
};
